import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { useIntersection } from 'shared/hooks/use-intersection'
import { PostAttachmentsProvider } from 'modules/attachments/components/context'
import { CommentEditor } from '../comment-editor'
import type { MessageBoxProps } from './message-box.types'
import { useCommentBox } from './use-comment-box'

export const StickyMessageBoxWithReply = ({
  parentId,
  setActiveComment = () => {},
  setOpenedResponses = () => {},
  onError,
  level = 0,
  replyInfo,
  onCommentAdded,
}: MessageBoxProps): ReactNode => {
  const { ref, entry } = useIntersection({ threshold: 1 })

  const { handleAddComment, attachmentsRef, setAttachments, initialHtml, initialMentions } =
    useCommentBox({
      parentId,
      level,
      setActiveComment,
      setOpenedResponses,
      onError,
      replyInfo,
      onCommentAdded,
    })

  return (
    <PostAttachmentsProvider ref={attachmentsRef} isEditable onChange={setAttachments}>
      <div
        data-comment-composer=""
        data-testid="sticky-comment-composer"
        className={twMerge(
          `sticky bottom-0 left-0 z-10 -mx-8 mt-4 w-[calc(100%+32px)] rounded-b-lg bg-bg-primary px-4 py-2 [overflow-anchor:none] sm:-mx-6 sm:w-[calc(100%+48px)] sm:px-6 md:-mx-8 md:w-[calc(100%+64px)] md:px-8`,
          !entry?.isIntersecting && 'shadow-2',
        )}
      >
        <CommentEditor
          onCancel={() => {
            setActiveComment(null)
          }}
          handleAddComment={handleAddComment}
          setActiveComment={setActiveComment}
          isRoot={false}
          initialHtml={initialHtml}
          initialMentions={initialMentions}
        />
      </div>
      <div ref={ref} aria-hidden className="-mt-px h-px [overflow-anchor:auto]" />
    </PostAttachmentsProvider>
  )
}
